import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import { t } from "../app/Translate";
import Footer from "../components/Footer";
import { motion } from "framer-motion";

import opcion1 from '../svg/00_Agenda-FC.svg';
import opcion2 from '../svg/00_Inventario-FC.svg';
import opcion3 from '../svg/00_Catalogo-FC.svg';
import opcion4 from '../svg/00_Nomina-FC.svg';
import opcion5 from '../svg/00_MPS-FC.svg';
import opcion6 from '../svg/00_Makos-Clock-FC.svg';

const Plans = () => {     
    const {isocode}: any = useParams();
    const navigate = useNavigate();
    
    function NavigateTo(){
        let urlRegister = "/" + isocode + "/faq/" 
        navigate(urlRegister);
    }

    return(
        <>
            <Header isocode={isocode} active="advanced"/>
            <main className="main-content">
                <section className="header-advanced" style={{paddingLeft:"10%"}}>
                    <div className="row" style={{paddingTop:"130px",textAlign:"left"}}>
                        <div className="col-md-6 bannertext1" style={{paddingLeft:"50px", paddingRight:"50px"}}>
                            {t("advanced.title")}
                            <div className="bannertext2">
                                {t("advanced.subtitle")}
                            </div>                            
                        </div>
                        <div className="col-md-6"></div>                        
                    </div>     
                    <br/><br/><br/>               
                </section>
                
                <div className="iconsmenuadv onlydesktop">
                    <div className="row" style={{paddingLeft:"140px", paddingRight:"140px", paddingBottom:"20px"}}>
                        <div className="col-md-2">
                            <a href="#option1" style={{textDecoration:"none"}}>
                                <img src={opcion1} className="iconmenuadv" />
                                <br/>
                                <span className="iconmenuadvtitle">{t("advanced.option1")}</span>
                            </a>
                        </div>
                        <div className="col-md-2">
                            <a href="#option2" style={{textDecoration:"none"}}>
                                <img src={opcion2} className="iconmenuadv" />
                                <br/>
                                <span className="iconmenuadvtitle">{t("advanced.option2")}</span>
                            </a>
                        </div>
                        <div className="col-md-2">
                            <a href="#option3" style={{textDecoration:"none"}}>
                                <img src={opcion3} className="iconmenuadv" />
                                <br/>
                                <span className="iconmenuadvtitle">{t("advanced.option3")}</span>
                            </a>
                        </div>
                        <div className="col-md-2">
                            <a href="#option4" style={{textDecoration:"none"}}>
                                <img src={opcion4} className="iconmenuadv" />
                                <br/>
                                <span className="iconmenuadvtitle">{t("advanced.option4")}</span>
                            </a>
                        </div>
                        <div className="col-md-2">
                            <a href="#option5" style={{textDecoration:"none"}}>
                                <img src={opcion5} className="iconmenuadv" />
                                <br/>
                                <span className="iconmenuadvtitle">{t("advanced.option5")}</span>
                            </a>
                        </div>
                        <div className="col-md-2">
                            <a href="#option6" style={{textDecoration:"none"}}>
                                <img src={opcion6} className="iconmenuadv" />
                                <br/>
                                <span className="iconmenuadvtitle">{t("advanced.option6")}</span>
                            </a>
                        </div>
                    </div>
                </div>

                <section id="option1" className="main-section padmakos" style={{paddingTop:"80px"}}>                    
                    <h2 className="advantage-title" style={{color:"#282C40"}}>{t("advanced.option1")}</h2>
                    <div className="row" style={{paddingTop:"40px"}}>
                        <div className="col-md-1"></div>                     
                        <div className="col-md-6">
                            <motion.img
                                src="../../images/Agenda-1a.png"
                                style={{width:"80%"}}
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>
                        <div className="col-md-4" style={{paddingTop:"0px",textAlign:"left"}}>                            
                            <div className="title-section1" style={{color:"#4946A6",fontSize:"20px",lineHeight:"25px"}}>
                                {t("advanced.option1title")}
                            </div>
                            <div className="body-section1" style={{color:"#282C40",fontSize:"20px", paddingTop:"15px", paddingBottom:"40px"}}>
                                <div className="action" dangerouslySetInnerHTML={{ __html: t("advanced.option1details") }} />                                 
                            </div>                            
                        </div>                  
                        <div className="col-md-1"></div>                                               
                    </div>
                    <div className="row" style={{marginTop:"70px",textAlign:"left"}}>
                        <div className="col-md-1"></div>    
                        <div className="col-md-5">
                            <div className="title-section1" style={{color:"#282C40",fontSize:"2.6rem",marginBottom:"50px"}}>
                                {t("advanced.benefit")}
                            </div>
                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option1benef1title")}</p>
                                <span>{t("advanced.option1benef1details")}</span>
                            </div>
                           
                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option1benef2title")}</p>
                                <span>{t("advanced.option1benef2details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option1benef3title")}</p>
                                <span>{t("advanced.option1benef3details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option1benef4title")}</p>
                                <span>{t("advanced.option1benef4details")}</span>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Agenda-Photo.png"
                                width={"100%"}                                
                                initial={{ opacity: 0, x: 100 }}   
                                whileInView={{ opacity: 1, x: 0 }} 
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                            /> 
                        </div>
                        <div className="col-md-1"></div>    
                    </div>
                </section>

                <section id="option2" className="main-section padmakos" style={{paddingTop:"80px",backgroundColor:"#282C40"}}>
                    <h2 className="advantage-title" style={{color:"#ffffff"}}>{t("advanced.option2")}</h2>
                    <h4 style={{color:"#DAAC55",fontWeight:"400",fontSize:"22px",paddingBottom:"40px"}} dangerouslySetInnerHTML={{ __html: t("advanced.option2tag") }} />
                    <div className="row">
                        <div className="col-md-1"></div>   
                        <div className="col-md-6">
                            <motion.img
                                src="../../images/INV-Avanzado-1b.png"
                                style={{width:"80%"}}
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>
                        <div className="col-md-4" style={{paddingTop:"10px",textAlign:"left"}}>                                                        
                            <div className="title-section1" style={{color:"#ffffff",fontSize:"20px",lineHeight:"25px"}}>
                                {t("advanced.option2title")}
                            </div>
                            <div className="body-section1" style={{color:"#ffffff",fontSize:"20px", paddingTop:"15px", paddingBottom:"40px"}}>
                                <div className="action" dangerouslySetInnerHTML={{ __html: t("advanced.option2details") }} />                                 
                            </div>                            
                        </div>     
                        <div className="col-md-1"></div>                                          
                    </div>
                    <div className="row" style={{marginTop:"70px",textAlign:"left"}}>
                        <div className="col-md-1"></div>   
                        <div className="col-md-5">
                            <div className="title-section1" style={{color:"#ffffff",fontSize:"2.6rem",marginBottom:"50px"}}>
                                {t("advanced.benefit")}
                            </div>
                            <div className="advantage-benef">
                                <p>{t("advanced.option1benef1title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option1benef1details")}</span>
                            </div>
                           
                            <div className="advantage-benef">
                                <p>{t("advanced.option1benef2title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option1benef2details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p>{t("advanced.option1benef3title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option1benef3details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p>{t("advanced.option1benef4title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option1benef4details")}</span>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Inventario-Photo-2.png"
                                width={"100%"}                                
                                initial={{ opacity: 0, x: 100 }}   
                                whileInView={{ opacity: 1, x: 0 }} 
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                            /> 
                        </div>
                        <div className="col-md-1"></div>   
                    </div>
                </section>

                <section id="option3" className="main-section padmakos">
                    <h2 className="advantage-title" style={{color:"#282C40",marginBottom:"40px"}}>{t("advanced.option3")}</h2>
                    <div className="row">
                        <div className="col-md-1"></div>   
                        <div className="col-md-6">
                            <motion.img
                                src="../../images/Catalogo-1.png"
                                style={{width:"80%"}}
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>
                        <div className="col-md-4" style={{paddingTop:"10px",textAlign:"left"}}>                            
                            <div className="title-section1" style={{color:"#282C40",fontSize:"2.2rem"}}>
                                {t("advanced.option3title")}
                            </div>
                            <div className="body-section1" style={{color:"#282C40",fontSize:"1.3rem"}}>
                                <div className="action" dangerouslySetInnerHTML={{ __html: t("advanced.option3details") }} />                                 
                            </div>                            
                        </div> 
                        <div className="col-md-1"></div>                                              
                    </div>
                    <div className="row" style={{marginTop:"70px",textAlign:"left"}}>
                        <div className="col-md-1"></div>
                        <div className="col-md-5">
                            <div className="title-section1" style={{color:"#282C40",fontSize:"2.6rem",marginBottom:"50px"}}>
                                {t("advanced.benefit")}
                            </div>
                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option3benef1title")}</p>
                                <span>{t("advanced.option3benef1details")}</span>
                            </div>
                           
                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option3benef2title")}</p>
                                <span>{t("advanced.option3benef2details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option3benef3title")}</p>
                                <span>{t("advanced.option3benef3details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option3benef4title")}</p>
                                <span>{t("advanced.option3benef4details")}</span>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Catalogo-Photo-2.png"
                                width={"100%"}                                
                                initial={{ opacity: 0, x: 100 }}   
                                whileInView={{ opacity: 1, x: 0 }} 
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                            /> 
                        </div>
                        <div className="col-md-1"></div>
                    </div>
                </section>

                <section id="option4" className="main-section padmakos" style={{padding:"70px",backgroundColor:"#282C40"}}>
                    <h2 className="whymakos-title" style={{color:"#ffffff",marginBottom:"30px"}}>{t("advanced.option4")}</h2>                    
                    <div className="row">
                        <div className="col-md-1"></div>
                        <div className="col-md-6">
                            <motion.img
                                src="../../images/Nomina-1.png"
                                style={{width:"80%"}}
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>
                        <div className="col-md-4" style={{paddingTop:"10px",textAlign:"left"}}>                            
                            <div className="title-section1" style={{color:"#ffffff",fontSize:"2.2rem"}}>
                                {t("advanced.option4title")}
                            </div>
                            <div className="body-section1" style={{color:"#ffffff",fontSize:"1.3rem"}}>
                                <div className="action" dangerouslySetInnerHTML={{ __html: t("advanced.option4details") }} />                                 
                            </div>                            
                        </div>                  
                        <div className="col-md-1"></div>                          
                    </div>
                    <div className="row" style={{marginTop:"70px",textAlign:"left"}}>
                        <div className="col-md-1"></div>
                        <div className="col-md-5">
                            <div className="title-section1" style={{color:"#ffffff",fontSize:"2.6rem",marginBottom:"50px"}}>
                                {t("advanced.benefit")}
                            </div>
                            <div className="advantage-benef">
                                <p>{t("advanced.option4benef1title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option4benef1details")}</span>
                            </div>
                           
                            <div className="advantage-benef">
                                <p>{t("advanced.option4benef2title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option4benef2details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p>{t("advanced.option4benef3title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option4benef3details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p>{t("advanced.option4benef4title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option4benef4details")}</span>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Nomina-Photo-2.png"
                                width={"100%"}                                
                                initial={{ opacity: 0, x: 100 }}   
                                whileInView={{ opacity: 1, x: 0 }} 
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                            /> 
                        </div>
                        <div className="col-md-1"></div>
                    </div>
                </section>

                <section id="option5" className="main-section padmakos">
                    <h2 className="whymakos-title" style={{color:"#282C40", paddingLeft:"0px", paddingRight:"0px"}}>{t("advanced.option5")}</h2>
                    <div className="row">
                        <div className="col-md-1"></div>
                        <div className="col-md-6">
                            <motion.img
                                src="../../images/MPS.png"
                                style={{width:"80%"}}
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>
                        <div className="col-md-4" style={{paddingTop:"10px",textAlign:"left"}}>                            
                            <div className="title-section1" style={{color:"#282C40",fontSize:"2.2rem"}}>
                                {t("advanced.option5title")}
                            </div>
                            <div className="body-section1" style={{color:"#282C40",fontSize:"1.3rem"}}>
                                <div className="action" dangerouslySetInnerHTML={{ __html: t("advanced.option5details") }} />                                 
                            </div>                            
                        </div>                  
                        <div className="col-md-1"></div>                          
                    </div>
                    <div className="row" style={{marginTop:"70px",textAlign:"left"}}>
                        <div className="col-md-1"></div>
                        <div className="col-md-5">
                            <div className="title-section1" style={{color:"#282C40",fontSize:"2.6rem",marginBottom:"50px"}}>
                                {t("advanced.benefit")}
                            </div>
                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option5benef1title")}</p>
                                <span>{t("advanced.option5benef1details")}</span>
                            </div>
                           
                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option5benef2title")}</p>
                                <span>{t("advanced.option5benef2details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option5benef3title")}</p>
                                <span>{t("advanced.option5benef3details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p style={{color:"#4946A6"}}>{t("advanced.option5benef4title")}</p>
                                <span>{t("advanced.option5benef4details")}</span>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/MPS-Photo-3.png"
                                width={"100%"}                                
                                initial={{ opacity: 0, x: 100 }}   
                                whileInView={{ opacity: 1, x: 0 }} 
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                            /> 
                        </div>
                        <div className="col-md-1"></div>
                    </div>
                </section>

                <section id="option6" className="main-section" style={{padding:"70px",backgroundColor:"#282C40"}}>
                    <h2 className="whymakos-title" style={{color:"#ffffff"}}>{t("advanced.option6")}</h2>                    
                    <div className="row">
                        <div className="col-md-1"></div>
                        <div className="col-md-6">
                            <motion.img
                                src="../../images/Makos-Clock.png"
                                style={{width:"80%"}}
                                initial={{ scale: 0, opacity: 0 }}
                                animate={{ scale: 1, opacity: 1 }}
                                transition={{ duration: 0.8, ease: "easeOut" }} 
                                whileInView={{ scale: 1, opacity: 1 }} 
                                viewport={{ once: true, amount: 0.5 }}                                 
                            />                            
                        </div>
                        <div className="col-md-4" style={{paddingTop:"10px",textAlign:"left"}}>                            
                            <div className="title-section1" style={{color:"#ffffff",fontSize:"2.2rem"}}>
                                {t("advanced.option6title")}
                            </div>
                            <div className="body-section1" style={{color:"#ffffff",fontSize:"1.3rem"}}>
                                <div className="action" dangerouslySetInnerHTML={{ __html: t("advanced.option6details") }} />                                 
                            </div>                            
                        </div>                  
                        <div className="col-md-1"></div>                          
                    </div>
                    <div className="row" style={{marginTop:"70px",textAlign:"left"}}>
                        <div className="col-md-1"></div>
                        <div className="col-md-5">
                            <div className="title-section1" style={{color:"#ffffff",fontSize:"2.6rem",marginBottom:"50px"}}>
                                {t("advanced.benefit")}
                            </div>
                            <div className="advantage-benef">
                                <p>{t("advanced.option6benef1title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option6benef1details")}</span>
                            </div>
                           
                            <div className="advantage-benef">
                                <p>{t("advanced.option6benef2title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option6benef2details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p>{t("advanced.option6benef3title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option6benef3details")}</span>
                            </div>

                            <div className="advantage-benef">
                                <p>{t("advanced.option6benef4title")}</p>
                                <span style={{color:"#ffffff"}}>{t("advanced.option6benef4details")}</span>
                            </div>
                        </div>
                        <div className="col-md-5">
                            <motion.img
                                src="../../images/Clock-Photo-2.png"
                                width={"100%"}                                
                                initial={{ opacity: 0, x: 100 }}   
                                whileInView={{ opacity: 1, x: 0 }} 
                                viewport={{ once: true }}
                                transition={{ duration: 0.8 }}
                            /> 
                        </div>
                        <div className="col-md-1"></div>
                    </div>
                </section>
   
                <section className="main-section2 padmakos">
                    <div className="bordercolors" style={{marginTop:"40px",marginBottom:"80px"}}>
                        <div className="bordercolorsbody">
                            <div className="row" style={{padding:"10px"}}>
                                <div className="col-md-1"></div>
                                <div className="col-md-6">
                                    <div className="cta-question" style={{color:"#282C40"}}>{t("plans.plusctaquestion")}</div>
                                    <div className="cta-message" style={{color:"#282C40"}}>{t("plans.plusctadetails")}</div>
                                </div>
                                <div className="col-md-4" style={{flexDirection:"column",display:"flex",paddingBottom:"70px", width:"100%"}}>                                                                        
                                     <center>                                    
                                        <button onClick={NavigateTo} className="animated-button" style={{width:"100%",marginTop:"10px"}}>{t("main.ctabutton")}</button>                                                                            
                                    </center>                                        
                                </div>
                                <div className="col-md-1"></div>
                            </div>                                                                     
                        </div>
                    </div>
                </section>

                <Footer isocode={isocode} />  
            </main>
        </>
    )
}

export default Plans;